import SummerPromo from './SummerPromo.component';
export default SummerPromo;